// extracted by mini-css-extract-plugin
export default {"buttonWrap":"BigButton_buttonWrap__EmDJw","buttonText":"BigButton_buttonText__GgUc-"};